// extracted by mini-css-extract-plugin
module.exports = {"container":"_2TUPI-t-7wLy_ADxYYoWl_"};